var map = {
	"./alpha_310.jpeg": 78352,
	"./alpha_400.jpeg": 66316,
	"./alpha_401.jpeg": 42995,
	"./bugfix.jpeg": 75764,
	"assets/thumbnails/alpha_310.jpeg": 78352,
	"assets/thumbnails/alpha_400.jpeg": 66316,
	"assets/thumbnails/alpha_401.jpeg": 42995,
	"assets/thumbnails/bugfix.jpeg": 75764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75905;